import React from 'react'
import styled from 'react-emotion'

const Column = styled.div(props =>`
  flex: 1;
  text-align: ${props.left ? 'left' : (props.center ? 'center' : 'right')};
  padding: 0 1rem;

  img {
    max-width: 100%;
  }
`)

const Section = styled.div(props =>`
  padding: 2rem 1rem;
  background: ${props.light ? '#F8F8F8' : (props.bgColor || '#fff')};
  color: ${props.color || 'inherit'};
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  @media (min-width: 800px) {
    padding: 4rem 5rem;
    flex-direction: row;
    min-height: 20rem;
  }

  @media (min-width: 1025px) {
    padding: 4rem 5rem;
  }
`)

export const SectionColumn = (props) => {
  return (
    <Column {...props}>{props.children}</Column>
  );
}


export const SectionTwoCol = (props) => {
  return (
    <Section {...props}>{props.children}</Section>
  );
}


// WEBPACK FOOTER //
// ./src/components/section/SectionTwoCol.js